import { request } from "@/utils/request";

// 获取常购清单
export const getOftenBuyList = (data) => {
  return request({
    url: "/product/mall/queryTotalFrequentPurchaseList",
    method: "POST",
    data: data,
  });
};
// 获取我的消息列表
export const noticeList = (data) => {
  return request({
    url: "/cms/mall/notice/queryPage",
    method: "POST",
    data: data,
  });
};

// 获取我的消息列表数量及提示
export const queryTitleAndNumber = (data) => {
  return request({
    url: "/cms/mall/notice/queryTitleAndNumber",
    method: "POST",
    data: data,
  });
};

// 获取省
export const queryAreaByParentId = (id) => {
  return request({
    url: `/user/public/queryAreaByParentId?parentId=${id}`,
    method: "GET",
  });
};
// 改变消息状态
export const infoStaus = (data) => {
  return request({
    url: "/cms/mall/notice/updateStatus",
    method: "POST",
    data: data,
  });
};

//根据id查询消息详情
export const noticeDetail = (data) => {
  return request({
    url: "/cms/mall/notice/queryById",
    method: "POST",
    data: data,
  });
};

//读取未读消息数量
export const countUnReadMessage = (data) => {
  return request({
    url: "/cms/mall/notice/countUnReadMessage",
    method: "POST",
    data: data,
  });
};
// 添加收货地址列表
export const addAddr = (params) => {
  return request({
    url: "/user/mall/addAddresses",
    method: "POST",
    data: params,
  });
};
// 编辑收货地址列表
export const editAddr = (params) => {
  return request({
    url: "/user/mall/editAddr",
    method: "POST",
    data: params,
  });
};
// 设置默认收货地址
export const setDefault = (params) => {
  return request({
    url: "/user/mall/setDefault",
    method: "POST",
    data: params,
  });
};
// 删除收货地址
export const delAddr = (params) => {
  return request({
    url: `/user/mall/delete/${params}`,
    method: "GET",
  });
};
// 新版本保存，编辑地址
export const saveOrUpdateAddress = (params) => {
  return request({
    url: `/user/mall/saveOrUpdateAddress`,
    method: "POST",
    data: params,
  });
};
// 个人中心近30天使用返利金额
export const getRebateUseBlance = (userId) => {
  return request({
    url: `/order/public/getRebateUseBlance?monNum=30&userId=${userId}`,
    method: "GET",
  });
};
// 个人中心客户的用户积分
export const getPrizeInfo = (userId) => {
  return request({
    url: `/user/mall/userPonts/${userId}`,
    method: "POST",
  });
};

// 全部已读
export const updateStatusList = (params) => {
  return request({
    url: `/cms/mall/notice/updateStatusList`,
    method: "POST",
    data: params,
  });
};

// 关注店铺
export const userFocusCompany = (params) => {
  return request({
    url: `/user/mall/userFocusCompany/list`,
    method: "POST",
    data: params,
  });
};

// 获取用户微信绑定状态
export const queryUserWxBindStatus = () => {
  return request({
    url: "/user/mall/queryUserWxBindStatus",
    method: "GET",
  });
};
